import {NeoModel, ValueObject} from '@singularsystems/neo-core';

@NeoModel
export default class PlatformSearchCriteria extends ValueObject{
  public targetMarketId: number = 0
  public platformId: number = 0
}